import { Categoria } from './Categoria'
import { Descricao } from './Descricao'
import { Titulo } from './Titulo'

export const SecaoPrincial = {
  Descricao: Descricao,
  Titulo: Titulo,
  Categoria: Categoria,
}
